import { createOrbyLinkWeb } from "../../components/OrbyProvider/OrbyLinkWeb.js";
import { createOrbyLinkReactNative } from "../../components/OrbyProvider/OrbyLinkReactNative.js";
import { isReactNative } from "../../utils/oauth.js";
// Export the appropriate implementation based on platform
export const createOrbyLink = (options) => {
    if (isReactNative()) {
        return createOrbyLinkReactNative(options);
    }
    return createOrbyLinkWeb(options);
};
